<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-700">
            <slot></slot>
        </label>
        <div class="mt-1 relative rounded-md shadow-sm">
            <slot name="input">

            </slot>
        </div>
        <!--
            <input v-bind:value="value" v-on:input="$emit('input', $event.target.value)"
                   class="form-input block w-full sm:text-sm sm:leading-5" placeholder=""/>
        -->
        <p class="mt-2 text-sm text-gray-500" v-if="hasHelperSlot">
            <slot name="helper"></slot>
        </p>
    </div>
</template>

<script>
export default {
    name: "InputField",

    //props: ['value'],

    computed: {
        hasHelperSlot() {
            return !!this.$slots['helper']
        },
    },

}
</script>

<style scoped>

</style>
